import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { formatCurrency } from '../utils/formatCurrency';
import { ArrowLeft, ArrowUpRight, ArrowDownLeft, ArrowLeftRight } from 'lucide-react';
import { format } from 'date-fns';
import { pt } from 'date-fns/locale';

export default function WalletDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/wallets/${id}`).then(res => { setData(res.data); setLoading(false); });
  }, [id]);

  if (loading || !data) {
    return <div className="skeleton" style={{ height: 400, borderRadius: 16 }} />;
  }

  const { wallet, transactions } = data;

  return (
    <div>
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button className="btn btn-ghost btn-icon" onClick={() => navigate('/wallets')}>
            <ArrowLeft size={20} />
          </button>
          <div>
            <h1 className="page-title">{wallet.name}</h1>
            <p className="page-subtitle">{wallet.currency} · {wallet.type}</p>
          </div>
        </div>
      </div>

      {/* Saldo */}
      <div className="card mb-lg" style={{ textAlign: 'center', padding: 32 }}>
        <p style={{ fontSize: 13, color: 'var(--text-tertiary)', marginBottom: 8 }}>Saldo Actual</p>
        <p className="text-mono" style={{ fontSize: 36, fontWeight: 800, color: 'var(--text-primary)' }}>
          {formatCurrency(wallet.current_balance, wallet.currency)}
        </p>
      </div>

      {/* Transações */}
      <div className="card">
        <div className="section-header">
          <h3 className="section-title">Últimas Transações</h3>
        </div>
        {transactions.length === 0 ? (
          <div className="empty-state">
            <p className="empty-state-title">Sem transações</p>
            <p className="empty-state-text">Ainda não existem transações nesta carteira.</p>
          </div>
        ) : (
          transactions.map((tx) => {
            const isExpense = tx.type === 'expense';
            const isTransfer = tx.type === 'transfer';
            const Icon = isExpense ? ArrowUpRight : isTransfer ? ArrowLeftRight : ArrowDownLeft;
            return (
              <div key={tx.id} className="transaction-item">
                <div className="transaction-icon" style={{
                  background: isExpense ? 'var(--accent-red-dim)' : isTransfer ? 'var(--accent-purple-dim)' : 'var(--accent-green-dim)',
                }}>
                  <Icon size={20} style={{ color: isExpense ? 'var(--accent-red)' : isTransfer ? 'var(--accent-purple)' : 'var(--accent-green)' }} />
                </div>
                <div className="transaction-info">
                  <div className="transaction-desc">{tx.description || tx.category?.name || 'Sem descrição'}</div>
                  <div className="transaction-meta">
                    <span>{tx.category?.name}</span>
                    <span>·</span>
                    <span>{format(new Date(tx.date), 'd MMM yyyy', { locale: pt })}</span>
                  </div>
                </div>
                <div className={`transaction-amount ${tx.type}`}>
                  {isExpense ? '-' : '+'}{formatCurrency(tx.amount, tx.currency)}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
